import * as constants from '@/common/constants';
import { get, post, put, del } from '@/utils/http';

const pendingDictionaryTreeListMap = new Map();

const clearDictionaryTreeListPending = (pendingKey, requestPromise) => {
    if (pendingDictionaryTreeListMap.get(pendingKey) === requestPromise) {
        pendingDictionaryTreeListMap.delete(pendingKey);
    }
};

// 业务分类树
export const getBusinessTreeList = (rootId, isRelatedDepartments) => {
    let params = { rootId: rootId, isRelatedDepartments: isRelatedDepartments };
    return get(constants.API_BUSINESS_TREE_LIST, params);
};
// 业务分类树 不走缓存
export const getBusinessTreeListNoCache = (rootId, isRelatedDepartments) => {
    let params = { rootId: rootId, isRelatedDepartments: isRelatedDepartments };
    return get(constants.API_BUSINESS_TREE_LIST_NOCACHE, params);
};
export const saveBusinessTreeNode = (treeNode) => {
    return post(constants.API_BUSINESS_TREE_SAVE, treeNode);
};

export const updateBusinessTreeNode = (treeNode) => {
    return put(constants.API_BUSINESS_TREE_UPDATE, treeNode);
};

export const deleteBusinessTreeNode = (nodeId) => {
    return del(constants.API_BUSINESS_TREE_DELETE.replace(':nodeId', nodeId));
};

export const dragBusinessTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(constants.API_BUSINESS_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};

export const copyBusinessTreeToCS = (treeNodeId) => {
    return post(constants.API_BUSINESS_TREE_PUSH_TO_CS, {treeNodeId});
};

// 应用商店业务分类树
export const getCustomerBusinessTreeList = (appId) => {
    return get(constants.API_CUSTOMER_BUSINESS_TREE_LIST, appId ? { appId } : {});
};

export const saveCustomerBusinessTreeNode = (treeNode) => {
    return post(constants.API_CUSTOMER_BUSINESS_TREE_SAVE, treeNode);
};

export const updateCustomerBusinessTreeNode = (treeNode) => {
    return put(constants.API_CUSTOMER_BUSINESS_TREE_UPDATE, treeNode);
};

export const deleteCustomerBusinessTreeNode = (nodeId) => {
    return del(constants.API_CUSTOMER_BUSINESS_TREE_DELETE.replace(':nodeId', nodeId));
};

export const dragCustomerBusinessTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(constants.API_CUSTOMER_BUSINESS_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};

// 字典树
export const getDictionaryTreeList = (rootId) => {
    let params = rootId ? { rootId } : {};
    let pendingKey = JSON.stringify(params);
    let requestPromise = pendingDictionaryTreeListMap.get(pendingKey);
    if (!requestPromise) {
        requestPromise = get(constants.API_DICTIONARY_TREE_LIST, params);
        pendingDictionaryTreeListMap.set(pendingKey, requestPromise);
    }
    return requestPromise.then((res) => {
        clearDictionaryTreeListPending(pendingKey, requestPromise);
        return res;
    }, (error) => {
        clearDictionaryTreeListPending(pendingKey, requestPromise);
        return Promise.reject(error);
    });
};

export const saveDictionaryTreeNode = (treeNode) => {
    return post(constants.API_DICTIONARY_TREE_SAVE, treeNode);
};

export const updateDictionaryTreeNode = (treeNode) => {
    return put(constants.API_DICTIONARY_TREE_UPDATE, treeNode);
};

export const deleteDictionaryTreeNode = (nodeId) => {
    return del(constants.API_DICTIONARY_TREE_DELETE.replace(':nodeId', nodeId));
};

export const dragDictionaryTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(constants.API_DICTIONARY_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};

export const copyDictionaryTreeToCs = (treeNodeId) => {
    return post(constants.API_DICTIONARY_TREE_PUSH_TO_CS, {treeNodeId});
};

// 应用商店字典树
export const getCustomerDictionaryTreeList = (appId) => {
    return get(constants.API_CUSTOMER_DICTIONARY_TREE_LIST, appId ? { appId } : {});
};

export const saveCustomerDictionaryTreeNode = (treeNode) => {
    return post(constants.API_CUSTOMER_DICTIONARY_TREE_SAVE, treeNode);
};

export const updateCustomerDictionaryTreeNode = (treeNode) => {
    return put(constants.API_CUSTOMER_DICTIONARY_TREE_UPDATE, treeNode);
};

export const deleteCustomerDictionaryTreeNode = (nodeId) => {
    return del(constants.API_CUSTOMER_DICTIONARY_TREE_DELETE.replace(':nodeId', nodeId));
};

export const dragCustomerDictionaryTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(constants.API_CUSTOMER_DICTIONARY_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};

// 流水号树
export const getSerialNumberTreeList = (rootId) => {
    return get(constants.API_SERIALNUMBER_TREE_LIST, rootId ? { rootId } : {});
};

export const saveSerialNumberTreeNode = (treeNode) => {
    return post(constants.API_SERIALNUMBER_TREE_SAVE, treeNode);
};

export const updateSerialNumberTreeNode = (treeNode) => {
    return put(constants.API_SERIALNUMBER_TREE_UPDATE, treeNode);
};

export const deleteSerialNumberTreeNode = (nodeId) => {
    return del(constants.API_SERIALNUMBER_TREE_DELETE.replace(':nodeId', nodeId));
};
export const deleteSerialNumber = (id) => {
    return del(constants.API_SERIALNUMBER_DELETE.replace(':id', id));
};

export const dragSerialNumberTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(constants.API_SERIALNUMBER_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};

export const getSerialNumber = (id, busiId, departId) => {
    if (busiId && departId) {
        return get(constants.API_SERIALNUMBER_NOW_PRIVATE1.replace(':id', id).replace(':busiId', busiId).replace(':departId', departId));
    } else {
        return get(constants.API_SERIALNUMBER_NOW.replace(':id', id));
    }
};
export const getSerialNumberDepAndOption = (id, departId, configOptionId) => {
    if (departId && configOptionId) {
        return get(constants.API_SERIALNUMBER_NOW_PRIVATE3.replace(':id', id).replace(':configOptionId', configOptionId).replace(':departId', departId));
    }
};
export const getSerialNumberDepartment = (param) => {
    return post(constants.API_SERIALNUMBER_NOW_DEPARTMENT, param);
};
export const getSerialNumberPlus = (param) => {
    return post(constants.API_SERIALNUMBER_NOW_PLUS, param);
};
export const upDateSerialNumberState = (param) => {
    return post(constants.API_SERIALNUMBER_NOW_UPDATESERIALNUMBERSTATE, param);
};

export const getSerialNumber2 = (instanceId, serialNumberRefId, serialNumberRelationFormId, serialNumberRelationFieldId) => {
    return get(constants.API_SERIALNUMBER_NOW_PRIVATE2.replace(':instanceId', instanceId).replace(':serialNumberRefId', serialNumberRefId).replace(':serialNumberRelationFormId', serialNumberRelationFormId).replace(':serialNumberRelationFieldId', serialNumberRelationFieldId));
};
export const updateRefSerialNumber = (id) => {
    return post(constants.API_SERIALNUMBER_UPDATEREFSERIALNUMBER.replace(':id', id));
};

export const getNumberStatus = (params) => {
    return get(constants.API_SERIALNUMBER_STATUS, params);
};

export const copySerialNumberTreeToCs = (treeNodeId) => {
    return post(constants.API_SERIALNUMBER_TREE_PUSH_TO_CS, {treeNodeId});
};

export const getSerialNumberTreeNodeById = (id) => {
    return get(constants.API_SERIALNUMBER_TREENODE.replace(':id', id));
};

export const checkSerialNumberIfExist = (serialNumber) => {
    return get(constants.API_SERIALNUMBER_CHECK_IF_EXIST.replace(':serialNumber', serialNumber));
};

// 应用商店流水号树
export const getCustomerSerialNumberTreeList = (appId) => {
    return get(constants.API_CUSTOMER_SERIALNUMBER_TREE_LIST, appId ? { appId } : {});
};

export const saveCustomerSerialNumberTreeNode = (treeNode) => {
    return post(constants.API_CUSTOMER_SERIALNUMBER_TREE_SAVE, treeNode);
};

export const updateCustomerSerialNumberTreeNode = (treeNode) => {
    return put(constants.API_CUSTOMER_SERIALNUMBER_TREE_UPDATE, treeNode);
};

export const deleteCustomerSerialNumberTreeNode = (nodeId) => {
    return del(constants.API_CUSTOMER_SERIALNUMBER_TREE_DELETE.replace(':nodeId', nodeId));
};
export const deleteCustomerSerialNumber = (id) => {
    return del(constants.API_CUSTOMER_SERIALNUMBER_DELETE.replace(':id', id));
};

export const dragCustomerSerialNumberTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(constants.API_CUSTOMER_SERIALNUMBER_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};

export const getCustomerSerialNumber = (id) => {
    return get(constants.API_CUSTOMER_SERIALNUMBER_NOW.replace(':id', id));
};

export const getCustomerNumberStatus = (params) => {
    return get(constants.API_CUSTOMER_SERIALNUMBER_STATUS, params);
};

// 应用配置树
export const getApplicationTreeList = (params) => {
    return get(constants.API_APPLICATION_TREE_LIST, params);
};

export const saveApplicationTreeNode = (treeNode) => {
    return post(constants.API_APPLICATION_TREE_SAVE, treeNode);
};

export const updateApplicationTreeNode = (treeNode) => {
    return put(constants.API_APPLICATION_TREE_UPDATE, treeNode);
};

export const deleteApplicationTreeNode = (nodeId) => {
    return del(constants.API_APPLICATION_TREE_DELETE.replace(':nodeId', nodeId));
};

export const dragApplicationTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(constants.API_APPLICATION_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};

export const getApplicationLimit = () => {
    return get(constants.API_APPLICATION_LIST);
};

// 公共文库树
export const getPublicLibraryTreeList = (params) => {
    return get(constants.API_PUBLICLIBRARY_TREE_LIST, params);
};

export const savePublicLibraryTreeNode = (treeNode) => {
    return post(constants.API_PUBLICLIBRARY_TREE_SAVE, treeNode);
};

export const updatePublicLibraryTreeNode = (treeNode) => {
    return put(constants.API_PUBLICLIBRARY_TREE_UPDATE, treeNode);
};

export const deletePublicLibraryTreeNode = (nodeId) => {
    return del(constants.API_PUBLICLIBRARY_TREE_DELETE.replace(':nodeId', nodeId));
};

export const dragPublicLibraryTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(constants.API_PUBLICLIBRARY_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};

export const deletePublicLibraryFile = (params) => {
    return post(constants.API_PUBLICLIBRARY_FILE_DELETE, params);
};

// 文件标签树
export const getFileTagsTreeList = (rootId) => {
    return get(constants.API_FILETAGS_TREE_LIST, rootId ? { rootId } : {});
};

export const saveFileTagsTreeNode = (treeNode) => {
    return post(constants.API_FILETAGS_TREE_SAVE, treeNode);
};

export const updateFileTagsTreeNode = (treeNode) => {
    return put(constants.API_FILETAGS_TREE_UPDATE, treeNode);
};

export const deleteFileTagsTreeNode = (nodeId) => {
    return del(constants.API_FILETAGS_TREE_DELETE.replace(':nodeId', nodeId));
};

export const dragFileTagsTreeNode = (draggingNodeId, dropNodeId, type) => {
    return post(constants.API_FILETAGS_TREE_DRAG, { draggingNodeId, dropNodeId, type });
};

// 文件标签及档案模板树
export const getFileTagsArchiveTemplateTreeList = (params) => {
    return get(constants.API_FILETAGS_ARCHIVETEMPLATE_TREE_LIST, params);
};

// 档案模板树
export const getArchiveTemplateTreeList = (params) => {
    return get(constants.API_ARCHIVE_TEMPLATE_TREE_LIST, params);
};
export const saveArchiveTemplateTreeNode = (treeNode) => {
    return post(constants.API_ARCHIVE_TEMPLATE_TREE_SAVE, treeNode);
};
export const updateArchiveTemplateTreeNode = (treeNode) => {
    return put(constants.API_ARCHIVE_TEMPLATE_TREE_UPDATE, treeNode);
};
export const deleteArchiveTemplateTreeNode = (nodeId) => {
    return del(constants.API_ARCHIVE_TEMPLATE_TREE_DELETE.replace(':nodeId', nodeId));
};
// export const dragArchiveTemplateTreeNode = (draggingNodeId, dropNodeId, type) => {
//   return post(constants.API_ARCHIVE_TEMPLATE_TREE_DRAG, { draggingNodeId, dropNodeId, type });
// };
export const deleteArchiveTemplateFile = (params) => {
    return post(constants.API_ARCHIVE_TEMPLATE_FILE_DELETE, params);
};

export const copyFileToTarget = (params) => {
    return post(constants.API_DOCUMENT_ARCHIVE_TEMPLATE_COPY_FILE, params);
};
export const getArchiveTemplateInstanceTreeList = (params) => {
    return get(constants.API_ARCHIVE_TEMPLATE_TREE_INSTANCE_LIST, params);
};

export const deleteArchiveTemplateInstanceFile = (params) => {
    return post(constants.API_ARCHIVE_TEMPLATE_FILE_INSTANCE_DELETE, params);
};
export const saveArchiveTemplateInstanceTree = (treeNode) => {
    return post(constants.API_ARCHIVE_TEMPLATE_TREE_INSTANCE_SAVE, treeNode);
};

export const saveArchiveInstanceFile = (params) => {
    return post(constants.API_ARCHIVE_TEMPLATE_FILE_INSTANCE_SAVE, params);
};

// 根据模板treeID获取其下的文件信息
export const getFilesListByTemplateTreeId = (params) => {
    return get(constants.API_FILES_LIST_BY_TEMPLATE_TREE_ID, params);
};
// 根据模板treeID获取其下的文件信息
export const getOrgUserTree = (params) => {
    return post(constants.API_ORG_USER_TREE, params);
};



// WEBPACK FOOTER //
// ./src/data-model/base/tree-model.js